module.exports = serialport;